<template>
  <v-container fluid class="user-list" v-if="languageData.labels && languageData.modalDelete">
    <v-row class="ma-0">
      <v-card elevation="0" width="100%" :class="layout === 'list' ? 'ma-1 px-3 py-4' : null">
        <v-card-text v-if="layout !== 'choosePerson'" :style="layout !== 'list' ? 'padding-left: 0; padding-top: 0; padding-right: 0' : null">
          <v-row no-gutters align="center" width="100%">
            <div v-if="layout === 'list'" class="search-input-container">
                <v-text-field
                    class="search-input"
                    background-color="bgDefault"
                    height="55px"
                    single-line
                    flat
                    solo
                    hide-details
                    :placeholder="languageData.labels.search"
                    @keyup="filtersClients"
                    v-model="searchName"
                    :label="languageData.labels.search"
                    prepend-inner-icon="mdi-magnify"
                   
                >
                </v-text-field>
            </div>
            <div :class="layout === 'list' ? 'search-button-container' : null">
              <v-btn height="55px" width="100%" class="search-button" to="/clients/add" color="primary" v-if="layout === 'list'">
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ languageData.btnAdd }}
              </v-btn>
              <v-btn @click="addClient" class="m search-button" color="primary" v-else-if="layout === 'projectStep' || layout === 'add'" :disabled="noClientType && clients.length > 0">
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ languageData.btnAddList }}
              </v-btn>
              <v-btn height="55px" width="100%" class="search-button" @click="showProjectForm" color="primary" v-else-if="layout === 'selectClient'">
                {{ languageData.btnAddList }}
              </v-btn>
              <v-btn height="55px" width="100%" class="search-button" @click="showOfferForm" color="primary" :disabled="disableAddButton" v-else-if="layout === 'offerSelectClient'">
                {{ languageData.btnAddList }}
              </v-btn>
            </div>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row class="ma-0">
      <v-card elevation="0" width="100%" class="ma-1">
          <template v-if="layout === 'projectStep' || layout === 'add'">
            <ClientsTableStatic :layout="layout" :clients="clients" :clientsTypes="clientsTypes" :noClientType="noClientType"></ClientsTableStatic>
          </template>
          <template v-else>
            <ClientsTableDynamic :layout="layout" :clients="clients" :headers="headers"></ClientsTableDynamic>
          </template>
      </v-card>
    </v-row>
  </v-container>
</template>

<script type="text/javascript">
import { mapActions, mapState } from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import clientTypes from "../../enums/ClientTypeEnum";
import ClientsTableStatic from "../ClientsTableStatic/ClientsTableStatic";
import ClientsTableDynamic from "../ClientsTableDynamic/ClientsTableDynamic";

export default {
  name: "ClientsTable",
  props: {
    layout: String,
    clients: Array,
    selectedId: Array,
    clientsTypes: Array,
    noClientType: Boolean,
  },
  data() {
    return {
      searchName: "",
      searchClientType: {
        value: null,
      },
      disableAddButton: false,
      searchTask: null,
      searchDebouceTime: 500
    }
  },
  components: {
    ClientsTableStatic,
    ClientsTableDynamic
  },
  methods: {
    ...mapActions("getClients", ["getClients", "setPagination" ,"getHeadersTable"]),
    addClient: function() {
      eventBus.$emit("showChooseClientModal");
    },
    showProjectForm: function() {
      eventBus.$emit("showProjectForm");
    },
    showOfferForm () {
      eventBus.$emit("showOfferForm");
    },
    filtersClients: function() {
      clearTimeout(this.searchTask);
      this.searchTask = setTimeout(() => {this.searchClients({}, true)}, this.searchDebouceTime);
    },
    searchClients : function(valueSearch={}, filters = false)
    {
      valueSearch.language = this.getCurrentLanguage;
      valueSearch.name = null;
      valueSearch.clientType = this.searchClientType.value;
      valueSearch.filters = filters;
      if(this.searchName !== "") {
        valueSearch.name = this.searchName;
      }
      this.getClients({valueSearch});
      if(filters) {
        this.currentPage = 1;
      }
    }
  },
  computed: {
    ...mapState("getClients", {
      headers: state => state.headers
    }),
    getClientTypes: () => {
      const clientTypesItems = [
        {
          value: null,
          name: "EVERYBODY"
        }
      ];
      return clientTypesItems.concat(clientTypes);
    },
  },
  mounted() {
    eventBus.$on("searchClients", (value) => {
      this.searchClients(value);
    });
    eventBus.$on("disableAddClientButton", (value) => {
      this.disableAddButton = value;
    });
    eventBus.$on('enableToSelectClient', (id) => {
      this.clients.find(el => el.id === id).disabled = false;
    })
    eventBus.$on('filterClientsTableDynamic', (searchValue) => {
      this.searchName = searchValue;
      this.filtersClients();
    })
  },
  beforeDestroy() {
    eventBus.$off('searchClients');
  }
}
</script>